module.exports = __webpack_public_path__ + "img/information.1bb6453a.svg";